import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Card, Space, Switch, Tabs, Tag, Typography, message } from 'antd';
import { useNavigate, useParams } from 'react-router-dom';
import { errorMessage } from '../api/client';
import { useInvestor, useUpdateInvestorStatus } from '../api/hooks';
import InvestmentsTab from '../components/investor/InvestmentsTab';
import LedgerTab from '../components/investor/LedgerTab';
import ProfileTab from '../components/investor/ProfileTab';
import ProfitTab from '../components/investor/ProfitTab';
import ReceiptsTab from '../components/investor/ReceiptsTab';
import WithdrawalsTab from '../components/investor/WithdrawalsTab';
import { useAuth } from '../context/AuthContext';

export default function InvestorDetailPage() {
  const { id } = useParams<{ id: string }>();
  const investorId = Number(id);
  const navigate = useNavigate();
  const { hasRole } = useAuth();
  const { data } = useInvestor(investorId);
  const updateStatus = useUpdateInvestorStatus();

  const toggleStatus = async (active: boolean) => {
    try {
      await updateStatus.mutateAsync({ id: investorId, status: active ? 'Active' : 'Inactive' });
      message.success(`Investor ${active ? 'activated' : 'deactivated'}.`);
    } catch (err) {
      message.error(errorMessage(err));
    }
  };

  return (
    <>
      <Space style={{ marginBottom: 16, flexWrap: 'wrap', justifyContent: 'space-between', width: '100%' }}>
        <Space>
          <Button icon={<ArrowLeftOutlined />} onClick={() => navigate('/investors')}>
            Back
          </Button>
          <Typography.Title level={4} style={{ margin: 0 }}>
            {data ? `${data.investorCode} — ${data.fullName}` : 'Investor'}
          </Typography.Title>
          {data && <Tag color={data.status === 'Active' ? 'green' : 'default'}>{data.status}</Tag>}
        </Space>

        {hasRole('Admin') && data && (
          <Space>
            <span>Active</span>
            <Switch checked={data.status === 'Active'} loading={updateStatus.isPending} onChange={toggleStatus} />
          </Space>
        )}
      </Space>

      <Card>
        <Tabs
          defaultActiveKey="profile"
          items={[
            { key: 'profile', label: 'Profile', children: <ProfileTab investorId={investorId} /> },
            { key: 'investments', label: 'Investments', children: <InvestmentsTab investorId={investorId} /> },
            { key: 'profit', label: 'Profit', children: <ProfitTab investorId={investorId} /> },
            { key: 'withdrawals', label: 'Withdrawals', children: <WithdrawalsTab investorId={investorId} /> },
            { key: 'ledger', label: 'Ledger', children: <LedgerTab investorId={investorId} /> },
            { key: 'receipts', label: 'Receipts', children: <ReceiptsTab investorId={investorId} /> },
          ]}
        />
      </Card>
    </>
  );
}
